export default {"src":"/_next/static/media/bottomCurved_bg_mobile4.9b071b24.svg","height":191,"width":375};